import { WindowToken } from "@app/util/window.token";
import { Inject, Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root',
})
export class Tools {

    constructor(@Inject(WindowToken) private window: any) {}

    openUrl(url) {
        this.window.open(url, '_blank');
    }

}
